import * as React from "react";
import { useCallback } from "react";
import { useField } from "formik";
import { ControlLabel } from "components/bootstrap";
import { TimezoneSelect } from "components/common";
function FormikTimezoneSelect({
  field,
  onChange = void 0,
  onBlur = void 0,
  label = void 0,
  disabled = false,
  menuPlacement = "bottom",
  maxMenuHeight = void 0
}) {
  const [_field, _meta, { setValue, setTouched }] = useField({ name: field.name });
  const handleChange = useCallback(
    (newValue) => {
      setValue(newValue);
      onChange == null ? void 0 : onChange(newValue);
    },
    [setValue, onChange]
  );
  const handleBlur = useCallback(() => {
    setTouched(true);
    onBlur == null ? void 0 : onBlur();
  }, [onBlur, setTouched]);
  return /* @__PURE__ */ React.createElement("div", { className: "form-group" }, label && /* @__PURE__ */ React.createElement(ControlLabel, null, label), /* @__PURE__ */ React.createElement(
    TimezoneSelect,
    {
      name: field.name,
      id: field.name,
      menuPlacement,
      maxMenuHeight,
      value: field.value,
      onChange: handleChange,
      onBlur: handleBlur,
      disabled
    }
  ));
}
export default FormikTimezoneSelect;
